module.exports = __webpack_public_path__ + "assets/f1d8b4805cafcd37974ad669fcb85ff5.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/drop/11/Drop_Bonus1.mp3
 ** module id = 206
 ** module chunks = 0
 **/